import { render, staticRenderFns } from "./monitor-add-or-update.vue?vue&type=template&id=a310c84c&scoped=true"
import script from "./monitor-add-or-update.vue?vue&type=script&lang=js"
export * from "./monitor-add-or-update.vue?vue&type=script&lang=js"
import style0 from "./monitor-add-or-update.vue?vue&type=style&index=0&id=a310c84c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a310c84c",
  null
  
)

export default component.exports